module.exports = __webpack_public_path__ + "img/oldlogo2.ecdd731b.png";